import axios from "axios";
import { endpoints } from "./endpoints";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "x-csrftoken";

export const apiDelete = {
  deleteCartItem,
  deleteAdminImage,
};

function deleteCartItem(cart_item_key) {
  return axios.delete(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_CART_ITEMS +
      cart_item_key +
      "/",
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    }
  );
}

function deleteAdminImage({ id }) {
  return axios.delete(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_SITE_ADMIN +
      id +
      "/" +
      endpoints.CSFA_DELETE_IMAGES,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    }
  );
}
